export const CATEGORY_COLORS = {
  Rescue: "#2196f3",
  Hazmat: "#ff9800",
  Operations: "#4caf50",
  Technology: "#9c27b0",
  Prevention: "#f44336",
  Leadership: "#00bcd4",
  "Fire Safety": "#e91e63",
  EMS: "#009688",
  Technical: "#795548",
  Other: "#607d8b",
};

export const colorFor = (category) =>
  CATEGORY_COLORS[category] || CATEGORY_COLORS.Other;

export const userName = (u) =>
  u
    ? u.firstName && u.lastName
      ? `${u.firstName} ${u.lastName}`
      : u.name || u.email || `User ${u.id}`
    : "";

export const initials = (name) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("");

export const WEEKDAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
